/* eslint-disable @typescript-eslint/quotes */
/* eslint-disable quotes */
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import NewButton from './NewButton'
const allowedPaths = ['/reset-password', '/new-password']

const MobileRedirect = (): JSX.Element => {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const isMobile = window.innerWidth < 868
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    if (isMobile && !allowedPaths.some((path: string) => pathname.startsWith(path))) {
      document.body.style.overflow = 'hidden'
      document.body.style.maxHeight = '100vh'
      document.body.style.maxWidth = '100vw'
      setShowModal(true)
    }
  }, [isMobile, pathname])

  if (showModal) {
    return (
      <div className="absolute top-0 left-0 bg-white flex flex-col items-center justify-center text-white p-4 w-screen h-screen z-[9999] overflow-scroll">
        <div className="max-w-96 w-full max-h-[842px] h-full px-8 pt-16 pb-8 bg-gradient-to-b from-white to-white/0 inline-flex flex-col justify-between items-start">
          <img className="max-w-72 w-full h-56" src="/assets/images/mobile-app-image.png" />
          <div className="self-stretch flex flex-col justify-start items-start gap-6">
            <div className="self-stretch flex flex-col justify-start items-start gap-2">
              <div className="self-stretch justify-center text-web-header text-xl font-bold font-Montserrat leading-normal">
                {t('mobile_redirect.title')}
              </div>
              <div className="self-stretch justify-center text-web-text-body text-base font-normal font-['Open Sans'] leading-relaxed">
                {t('mobile_redirect.subtitle')}
              </div>
            </div>
            <div className="self-stretch justify-center">
              <span className="text-web-text-body text-sm font-normal font-['Open Sans'] leading-snug">
                1. {t('mobile_redirect.step1')}
                <br />
                2. {t('mobile_redirect.step2')}{' '}
              </span>
              <span className="text-web-text-body text-sm font-bold font-['Open Sans'] leading-snug">
                {t('mobile_redirect.step2_highlight')}
              </span>
              <span className="text-web-text-body text-sm font-normal font-['Open Sans'] leading-snug">
                {' '}
                <br />
                3. {t('mobile_redirect.step3')}
                <br />
                4. {t('mobile_redirect.step4')}
              </span>
            </div>
            <div className="flex gap-4">
              <a
                href="https://play.google.com/store/apps/details?id=com.estigroup.dealerapp"
                target="_blank"
                rel="noopener noreferrer">
                <img className="h-12" src="/assets/images/google-play.svg" alt={t('mobile_redirect.google_play')} />
              </a>
              <a href="https://apps.apple.com/app/id6469692534" target="_blank" rel="noopener noreferrer">
                <img className="h-12" src="/assets/images/app-store-badge.svg" alt={t('mobile_redirect.app_store')} />
              </a>
            </div>
            <div className="w-full flex justify-center pb-22">
              <NewButton
                buttonType="blue"
                buttonVariant="xlarge"
                onClick={() => {
                  window.location.href = `com.estigroup.dealerapp://${pathname.replace('/browsing/', '')}`
                }}>
                {t('mobile_redirect.open_app')}
              </NewButton>
            </div>
          </div>
        </div>
      </div>
    )
  }
  return <></>
}

export default MobileRedirect
